export default __webpack_public_path__ + "static/media/j5.984c0f99.png";